import React from 'react';
import { Icon, Label } from '@nooz-optics/nooz-components-lib';
import { formatContentfulComponentProps } from '../../../../utils/globals';
import { Button } from '../../Elements';
import { FooterNavigationList } from './Navigation';
import { FooterNoozletter } from './Noozletter/noozletter';
import { FooterBottom } from './Bottom';
import { Disclosure } from '../../Navigation/Disclosure/disclosure';
import { IBlock } from '../../../../utils/types/contentful';
import { LanguageCurrencySwitch } from '../LanguageCurrencySwitch';
import { Link } from '../../Elements/Link';
import { Component } from '../../../Contentful/component';

export interface IFooterProps {
  navigations: IBlock;
  social: IBlock;
  legal: IBlock;
  newsletter: IBlock;
  payments: IBlock;
  languageCurrencySwitch: IBlock;
}

export const PureFooter = ({
  navigations,
  social,
  legal,
  newsletter,
  payments,
  languageCurrencySwitch,
  reassurances,
  instafeed,
}: IFooterProps) => {
  const returnSocialNavigation = () =>
    social?.items?.map((item) => (
      <div className='mr-2'>
        <Button
          type='outlined'
          color={{ classname: 'white' }}
          size='lg'
          isCircular>
          <div className='w-full flex justify-center items-center'>
            <Link
              {...item}
              icon={{
                ...item.icon,
                size: 'base',
              }}
            />
          </div>
        </Button>
      </div>
    ));

  return (
    <footer
      className='bg-primary'
      aria-labelledby='footer-heading'>
      <Component {...reassurances} />
      <div className='main-wrapper mx-auto py-12 px-5 xl:px-0 lg:py-16'>
        <div className='mt-16 lg:mt-0'>
          <Component {...instafeed} />
        </div>
        <div className='my-8'>
          <Icon
            iconKey='NoozLogo'
            color={{ hex: 'white' }}
            size='8xl'
          />
          <div className='flex'>{returnSocialNavigation()}</div>
        </div>
        <div className='flex flex-wrap'>
          <div className='w-full lg:w-1/2'>
            <div className='mb-8'>
              <LanguageCurrencySwitch
                {...formatContentfulComponentProps(languageCurrencySwitch)}
                isWhite
              />
            </div>
          </div>
          <div className='mb-8 sm:w-full lg:w-1/2'>
            <FooterNoozletter {...formatContentfulComponentProps(newsletter)} />
          </div>
          {navigations?.items.map((nav) => (
            <div className='hidden mb-8 pr-6 sm:block sm:w-1/2 lg:w-1/4'>
              <FooterNavigationList navigations={nav} />
            </div>
          ))}
        </div>
        <div className='sm:hidden'>
          {navigations?.items.map((nav) => {
            const button = (
              <div className='text-2xl  font-bold'>
                <Label
                  {...(nav.items && nav.items[0])}
                  weight='medium'
                  size='inherit'
                />
              </div>
            );

            const chevron = (
              <Icon
                iconKey='HiChevronDown'
                size='2xl'
                color={{ classname: 'white' }}
              />
            );

            return (
              <div className='block text-white sm:w-1/2 lg:w-1/4 py-3'>
                <Disclosure
                  defaultOpen
                  button={button}
                  chevronIcon={chevron}>
                  <FooterNavigationList navigations={nav} />
                </Disclosure>
              </div>
            );
          })}
        </div>

        <FooterBottom
          social={social}
          legal={legal}
          payments={payments}
        />
      </div>
    </footer>
  );
};

export const Footer = (props) => (
  <PureFooter {...formatContentfulComponentProps(props)} />
);
